import { Button } from "../ui/Button";

export type QuoteSource = "type" | "screenshot" | "board";

export function QuoteSourcePicker({
  onPick,
  disabled,
}: {
  onPick: (source: QuoteSource) => void;
  disabled?: boolean;
}) {
  return (
    <div className="row" data-testid="quote-source-picker">
      <Button disabled={disabled} onClick={() => onPick("type")}>
        Type it
      </Button>
      <Button disabled={disabled} onClick={() => onPick("screenshot")}>
        Screenshot
      </Button>
      <Button disabled={disabled} onClick={() => onPick("board")}>
        Board
      </Button>
    </div>
  );
}
